module.exports = "<div \n    class=\"bk-root\" \n    [style.width]=\"plot_width + 'px'\" \n    [style.height]=\"plot_height + 'px'\">\n  <div #bokehplot></div>\n</div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/bokeh-components/bokeh-plot.html
 ** module id = 202
 ** module chunks = 0
 **/